import emergencyContacts from './emergencyContacts'

export default { emergencyContacts }
